import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_SUBCONTRACTOR,
  API_CREATE_SUBCONTRACTOR,
  API_LOAD_SUBCONTRACTORS,
  API_REMOVE_SUBCONTRACTOR,
  API_UPDATE_SUBCONTRACTOR,
  REMOVE_LOCAL_SUBCONTRACTOR,
} from './subContractor.reducer';

export const load = () => ({ resourceAction: API_LOAD_SUBCONTRACTORS });
export const save = resource => ((isLocal(resource.id)) ? {
  resourceAction: API_CREATE_SUBCONTRACTOR,
  resource,
} : { resourceAction: API_UPDATE_SUBCONTRACTOR, resource });
export const add = () => ({ type: ADD_LOCAL_SUBCONTRACTOR });
export const remove = id => ((isLocal(id)) ? {
  type: REMOVE_LOCAL_SUBCONTRACTOR,
  id,
} : { resourceAction: API_REMOVE_SUBCONTRACTOR, id });



// WEBPACK FOOTER //
// ./src/reducers/subContractor/subContractor.actions.js